import { useEffect } from "react";
import { useNavigate } from "react-router";
import { supabase } from "@/lib/supabase";

/**
 * Listens for Supabase's PASSWORD_RECOVERY auth event and routes to the reset
 * form. The recovery email link lands on the configured Site URL (usually the
 * app root) with the recovery token in the URL; supabase-js consumes it and
 * emits PASSWORD_RECOVERY. Without this, the token is detected but nothing
 * reacts, so the reset form is never shown.
 */
export default function RecoveryRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (
        event === "PASSWORD_RECOVERY" &&
        window.location.pathname !== "/reset-password"
      ) {
        navigate("/reset-password", { replace: true });
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return null;
}
